/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface ActiveSubstancesWithEffect
 */
export interface ActiveSubstancesWithEffect {
    /**
     * 
     * @type {Array<number>}
     * @memberof ActiveSubstancesWithEffect
     */
    'activeSubstancesIds': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ActiveSubstancesWithEffect
     */
    'effect': ActiveSubstancesWithEffectEffectEnum;
    /**
     * 
     * @type {string}
     * @memberof ActiveSubstancesWithEffect
     */
    'lastUsage'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ActiveSubstancesWithEffectEffectEnum {
    Remission = 'REMISSION',
    BigImprovement = 'BIG_IMPROVEMENT',
    LittleImprovement = 'LITTLE_IMPROVEMENT',
    NoChange = 'NO_CHANGE',
    LittleDeterioration = 'LITTLE_DETERIORATION',
    BigDeterioration = 'BIG_DETERIORATION',
    ExtremeDeterioration = 'EXTREME_DETERIORATION'
}


